(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTemplateDetailController', PatientTemplateDetailController);

    PatientTemplateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PatientTemplate', 'Patient', 'Corporation'];

    function PatientTemplateDetailController($scope, $rootScope, $stateParams, previousState, entity, PatientTemplate, Patient, Corporation) {
        var vm = this;

        vm.patientTemplate = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:patientTemplateUpdate', function(event, result) {
            vm.patientTemplate = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
